module.exports = __webpack_public_path__ + "static/media/result_lsd_ja.d294bec2.png";